<template>
  <ul>
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'device-specification-entry-wrapper',
  data () {
    return {
      childComps: [],
      selectedChild: ''
    }
  },
  props: {
    value: {
      required: true,
      default: ''
    },
    allowMultiple: Boolean, // maybe later
    allowClose: Boolean
  },
  computed: {
    childList () {
      return this.childComps
    }
  },
  methods: {
    selectChild (name) {
      this.childList.forEach(child => {
        if (name === child.name) {
          if (!child.isOpen) {
            child.isOpen = true
            this.$emit('change', name)
          } else {
            child.isOpen = false
            this.$emit('change', null)
          }
          this.selectedChild = name
        } else {
          child.isOpen = false
        }
      })
    }
  },
  watch: {
    value (newVal) {
      this.selectChild(newVal)
    }
  },
  mounted () {
    this.childComps = this.$children
    if (this.childComps.length) {
      if (this.$props.value) {
        this.selectChild(this.$props.value)
      }
    }
  }
}
</script>

<style scoped>

</style>
